/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[matTooltip]:not([aria-label])',
    standalone: false
})
export class CmTooltipLabelDirective implements OnChanges {
	@Input() matTooltip?: string;
	@Input() skipAriaLabel: boolean = false;
	@Input() prependToAriaLabel: string = '';
	@Input() appendToAriaLabel: string = '';

	constructor(private readonly elRef: ElementRef, private readonly renderer: Renderer2) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			!this.skipAriaLabel &&
			(changes['matTooltip'] || {}).previousValue !== (changes['matTooltip'] || {}).currentValue
		) {
			this.renderer.setAttribute(
				this.elRef.nativeElement,
				'aria-label',
				`${this.prependToAriaLabel}${this.matTooltip}${this.appendToAriaLabel}`
			);
		}
	}
}
